import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { CreateCustomImageComponent } from './create-custom-image.component/create-custom-image.component';
import { TenantCustomImageComponent } from './tenant-custom-image.component';
import { ExternalTenantGuard } from 'src/app/services/util/external-tenant.guard';

const routes: Routes = [
  {
    path: '',
    component: TenantCustomImageComponent,
    title: 'Tenant Custom Image',
    canActivate: [ExternalTenantGuard]
  },
  {
    path: 'create',
    component: CreateCustomImageComponent,
    title: 'Tenant Custom Image',
    canActivate: [ExternalTenantGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TenantCustomImageRoutingModule {
}
